'use strict';
import classNames from 'classnames';
import get from 'lodash/get';
import * as T from 'prop-types';
import React, {Component} from 'react';
import {getId} from '../../../core-utilities/domain/ReduxUtils';
import {getMessagesFromProps} from '../../../core-utilities/react-i18n';
import {getItemClass} from '../../../core-utilities/redux/utils';
import {getFileRequirementMetrics} from '../../../tasks/components/TaskItem';
import {getScheduleStatus} from '../../../tasks/domain/utils';
import {autoPrioritiesListActions} from '../../actions/autoListActions';
import {pinnedPrioritiesListActions} from '../../actions/pinnedListActions';
import {getToggledPriority, USER_PRIORITY} from '../../enums/USER_PRIORITIES';
import {getTargetDate} from '../../redux/prioritiesListConfig';
import {UserPinView} from './UserPinView';


// Note: exported for testing
// TODO(fuse): convert $ngRedux to fuse container
export class UserPinComponent extends Component {
  static propTypes = {
    userId: T.string.isRequired,
    model: T.object.isRequired,

    onClick: T.func.isRequired,
    onContextMenu: T.func.isRequired,

    init: T.bool,
  };

  static defaultProps = {
    init: true,
  };

  static messages = UserPinView.messages;
  static messageProps = UserPinView.messageProps;

  static $inject = [
    '$ngRedux',
  ];

  constructor(props) {
    super(props);
    this.state = {
      targetName: '',
      description: '',
      parentName: '',
      organizationName: '',
    };

    this.handleTogglePin = this.handleTogglePin.bind(this);
  }

  static getDateLabel(taskStatus) {
    switch (taskStatus) {
      case 'submitted':
      case 'approved':
        return 'complete';
      case 'cancelled':
        return 'cancelled';
      default:
        return 'due';
    }
  }

  handleTogglePin(e) {
    e.preventDefault();
    if (this.props.model && !this.props.model.isToggling) {
      const currentPriority = get(this.props.model, 'priority');
      const nextPriority = getToggledPriority(currentPriority);
      const id = getId(this.props.model);
      const togglePinCreator = currentPriority === USER_PRIORITY.PINNED
        ? pinnedPrioritiesListActions.togglePin
        : autoPrioritiesListActions.togglePin;

      // eslint-disable-next-line max-len
      UserPinComponent.dependencies.$ngRedux.dispatch(togglePinCreator({
        model: this.props.model,
        id,
        priority: nextPriority,
      }));
    }
  }

  render() {
    const props = this.props;
    const model = props.model || {metadata: {}, target: {}};
    const target = model.target ? model.target : {};

    return (
      <UserPinView
        className={classNames(props.className, getItemClass(model))}
        userId={props.userId}
        model={model}
        target={target}
        targetName={target.name}
        description={target.description}
        parentName={model.metadata.parentName}
        organizationName={model.metadata.organizationName}
        isPinned={model.priority === USER_PRIORITY.PINNED}

        selectedDateLabel={UserPinComponent.getDateLabel(target.status)}
        taskStatus={target.status}
        taskDate={getTargetDate(model)}
        scheduleStatus={getScheduleStatus(target)}
        useTime={target.useTime}
        fileCountLabel={getFileRequirementMetrics(target.metrics)}

        onClick={props.onClick}
        onContextMenu={props.onContextMenu}
        onTogglePin={this.handleTogglePin}

        init={props.init}
        {...getMessagesFromProps(props, UserPinView.messageProps)}
      />
    );
  }
}



// WEBPACK FOOTER //
// ./src/js/priorities/components/UserPin/UserPinComponent.js